import { useEffect, useState } from 'react';
import { Grid, Stack, TextField, Typography } from '@mui/material';

import Form from 'components/Form';
import { INames } from 'apis/main/type';
import { getNandaClass, getNandaDiagnosis } from 'apis/main';

interface Props {
  watch: any;
  setValue: any;
  register: any;
  disabled?: boolean;
  domainNames?: INames[];
}

function Nanda(props: Props) {
  const { watch, register, setValue, domainNames, disabled } = props;

  const m_domain = watch('domain');

  // GetNandaClass
  const m_class = watch('class');
  const [classNames, setClassNames] = useState<INames[]>([]);
  useEffect(() => {
    if (!m_domain || m_domain === 'none') return setClassNames([]);
    getNandaClass({ domain: m_domain }).then(({ data }) => {
      setClassNames(data.names);
      setDiagnosisNames([]);
    });
  }, [m_domain]);

  // GetNandaDiagnosis
  const [diagnosisNames, setDiagnosisNames] = useState<INames[]>([]);
  useEffect(() => {
    if (!m_class || m_class === 'none') return setDiagnosisNames([]);
    getNandaDiagnosis({ domain: m_domain, class: m_class }).then(({ data }) => {
      setDiagnosisNames(data.names);
    });
  }, [m_domain, m_class]);

  // Render Select Options
  const getOptionValue = (option: INames) => option.eng;
  const getOptionLabel = (option: INames) => option.eng;

  return (
    <Stack spacing={2}>
      <Grid
        container
        wrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        spacing={0.75}
      >
        <Grid item xs={4}>
          <Typography variant="caption">Domain</Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={domainNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            {...register('domain')}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption">Class</Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={classNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            value={watch('class')}
            {...register('class')}
          />
        </Grid>
        <Grid item xs={4}>
          <Typography variant="caption">診斷</Typography>
        </Grid>
        <Grid item xs={8}>
          <Form.MuiSelect
            isNone
            disabled={disabled}
            options={diagnosisNames}
            getOptionValue={getOptionValue}
            getOptionLabel={getOptionLabel}
            value={watch('diagnosis')}
            {...register('diagnosis')}
          />
        </Grid>
      </Grid>

      <Form.Item label="Subjective/Objective Data Collection">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('collectingData')}
        />
      </Form.Item>

      <Form.Item label="Short-term/Long-term Goal">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('goal')}
        />
      </Form.Item>

      <Form.Item label="Nursing Plan">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('plan')}
        />
      </Form.Item>

      <Form.Item label="Interventions">
        <TextField
          // required
          fullWidth
          multiline
          minRows={5}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('interventions')}
        />
      </Form.Item>

      <Form.Item label="Nursing Evaluation">
        <TextField
          // required
          fullWidth
          multiline
          minRows={3}
          size="small"
          variant="outlined"
          disabled={disabled}
          {...register('evaluation')}
        />
      </Form.Item>
    </Stack>
  );
}

export default Nanda;
